import React, { PureComponent } from 'react'

import ProfileMenu from './profileMenu/profileMenu.component'

import './header.component.scss'

/**
 * Header Component
 * @returns {*}
 */
class Header extends PureComponent {

  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      profileMenuAnchor: null
    }
  }

  /**
   * Toggle Profile Menu
   * @param event
   * @param toggle - override
   */
  toggleProfileMenu = (event, toggle) => {
    const show = (typeof toggle !== 'undefined') ? toggle : !this.state.profileMenuAnchor
    this.setState({
      profileMenuAnchor: show ? event.currentTarget : null
    })
  }

  render () {
    const { profile, history, auth } = this.props
    const { profileMenuAnchor } = this.state

    return (
      <div className='app-header'>
        <div className='app-header_details'>
          {profile
            ? <>
              <div className={`details-menu_button ${profileMenuAnchor ? 'details-menu_button--active' : ''}`}
                   onClick={this.toggleProfileMenu}>
                {profile.picture ? <img className='details-menu_image' src={profile.picture} alt='profile' /> :
                  <i className={'details-menu_icon q4i-contact-2pt'} />}
              </div>
              <ProfileMenu
                anchorEl={profileMenuAnchor}
                auth={auth}
                history={history}
                profile={profile}
                onClose={(e) => this.toggleProfileMenu(e, false)} />
            </>
            : null}
        </div>
      </div>
    )
  }
}

export default Header
